module.exports = __webpack_public_path__ + "static/img/tg2.96cb3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tg2.jpg
// module id = SMV8
// module chunks = 1